import { VueConstructor } from 'vue'
import { Vue } from 'vue/types/vue'

export const BaseUrlPlugin = {
  install(Vue: VueConstructor) {
    Vue.prototype.$baseURL = process.env.VUE_APP_BASE_URL
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $baseURL: string;
  }
}
